(function () {
  var MERCHANT = 'their-nibs';
  var API_BASE = 'https://api.feefo.com/api/10/reviews/summary/product';

  function loadRatings() {
    var containers = document.querySelectorAll('[data-feefo-product-sku]');
    if (!containers.length) return;

    containers.forEach(function (el) {
      var sku = el.getAttribute('data-feefo-product-sku');
      var scoreEl = el.querySelector('.product-rating__score');
      if (!sku || !scoreEl) return;

      fetch(API_BASE + '?merchant_identifier=' + MERCHANT + '&parent_product_sku=' + sku)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var count = data && data.rating && data.rating.product && data.rating.product.count;
          var score = data && data.rating && data.rating.rating;
          if (!count || !score) return;
          scoreEl.textContent = parseFloat(score).toFixed(1);
          el.style.visibility = 'visible';
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRatings);
  } else {
    loadRatings();
  }
})();
